module.exports = __webpack_public_path__ + "static/media/icon-arrow.1969da21.svg";